import { cn } from "@/lib/utils";
import React from "react";

export const HardwareGridSkeleton: React.FC<{
  usesMainContentScroll?: boolean;
  showSummaryPanel?: boolean;
}> = ({ usesMainContentScroll = false, showSummaryPanel = false }) => {
  const gridColumnClasses = usesMainContentScroll
    ? "md:grid-cols-2 xl:grid-cols-3 3xl:grid-cols-4"
    : showSummaryPanel
      ? "xl:grid-cols-2"
      : "md:grid-cols-2 xl:grid-cols-3 3xl:grid-cols-4";

  return (
    <div
      className={cn(
        "grid grid-cols-1 gap-4",
        !usesMainContentScroll && "custom-scrollbar h-[500px] overflow-y-auto",
        gridColumnClasses
      )}
    >
      {Array.from({ length: 6 }).map((_, idx) => (
        <div
          key={`hardware-skeleton-${idx}`}
          className="rounded-[8px] border border-gray-dark-200 bg-white dark:bg-gray-dark-600"
        >
          <div className="flex items-center gap-3 p-4">
            <div className="h-[24px] w-[24px] animate-pulse rounded bg-separator dark:bg-gray-dark-700" />
            <div className="h-5 w-40 animate-pulse rounded bg-separator dark:bg-gray-dark-700" />
            <div className="ml-2 h-5 w-10 animate-pulse rounded bg-separator dark:bg-gray-dark-700" />
            <div className="flex-1" />
            <div className="h-[24px] w-[24px] rounded-full border border-gray-dark-200" />
          </div>
          <div className="flex flex-col gap-4 border-t border-gray-dark-200 p-4">
            <div className="flex items-center justify-between">
              <div className="h-4 w-24 animate-pulse rounded bg-separator dark:bg-gray-dark-700" />
              <div className="h-4 w-20 animate-pulse rounded bg-separator dark:bg-gray-dark-700" />
            </div>
            <div className="flex items-center justify-between">
              <div className="h-4 w-32 animate-pulse rounded bg-separator dark:bg-gray-dark-700" />
              <div className="h-4 w-24 animate-pulse rounded bg-separator dark:bg-gray-dark-700" />
            </div>
            <div className="flex items-center justify-between">
              <div className="h-4 w-20 animate-pulse rounded bg-separator dark:bg-gray-dark-700" />
              <div className="h-4 w-24 animate-pulse rounded bg-separator dark:bg-gray-dark-700" />
            </div>
            <div className="flex items-center justify-between">
              <div className="h-4 w-24 animate-pulse rounded bg-separator dark:bg-gray-dark-700" />
              <div className="h-4 w-24 animate-pulse rounded bg-separator dark:bg-gray-dark-700" />
            </div>
            <div className="ml-auto h-7 w-24 animate-pulse rounded bg-separator dark:bg-gray-dark-700" />
          </div>
        </div>
      ))}
    </div>
  );
};
